module.exports = __webpack_public_path__ + "static/media/dtan.087b7886.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dtan.png
// module id = 1746
// module chunks = 0 1